import { LOCAL_STORAGE_PAYMENT_BOOKING_ID, LOCAL_STORAGE_PAYMENT_ID } from '~/types/payment';

/** `bookingId` scopes the payment to one booking, so another tab or an old payment can't be resumed by mistake. */
export function setPaymentId(paymentId: string, bookingId?: string): void {
  localStorage.setItem(LOCAL_STORAGE_PAYMENT_ID, paymentId);

  if (bookingId) {
    localStorage.setItem(LOCAL_STORAGE_PAYMENT_BOOKING_ID, bookingId);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_PAYMENT_BOOKING_ID);
  }
}

/** With a `bookingId`, returns the payment only if it was stored for that same booking. */
export function getPaymentId(bookingId?: string): string | null {
  if (bookingId && localStorage.getItem(LOCAL_STORAGE_PAYMENT_BOOKING_ID) !== bookingId) {
    return null;
  }

  return localStorage.getItem(LOCAL_STORAGE_PAYMENT_ID);
}

export function clearPayment(): void {
  localStorage.removeItem(LOCAL_STORAGE_PAYMENT_ID);
  localStorage.removeItem(LOCAL_STORAGE_PAYMENT_BOOKING_ID);
}
